import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { IconButton } from '@atlaskit/button/new';
import { defineMessages, useIntl } from 'react-intl-next';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
  markAsRead: {
    id: 'app-updates-table.unread-dot.mark-as-read',
    defaultMessage: 'Mark as read',
  },
});

const styles = {
  dot: xcss({
    width: token('space.100'),
    height: token('space.100'),
    borderRadius: 'radius.full',
    backgroundColor: 'color.background.accent.blue.bolder',
    display: 'block',
  }),
};

interface UnreadDotProps {
  onClick: () => void;
  testId?: string;
}

export const UnreadDot: React.FC<UnreadDotProps> = ({ onClick, testId }) => {
  const { formatMessage } = useIntl();

  return (
    <IconButton
      testId={testId}
      appearance="subtle"
      icon={(props) => <Box {...props} xcss={styles.dot} />}
      spacing="compact"
      onClick={onClick}
      label={formatMessage(messages.markAsRead)}
    />
  );
};
